<template>
    <div class="form_submit">
        <div :class="{btns}">
            <me-button
                v-if="btns"
                class="cancel"
                type="default"
                block
                @click="cancel">{{cancelText}}</me-button>
            <me-button
                type="primary"
                block
                @click="confirm"
                color="#06B455">{{text}}</me-button>
        </div>
    </div>
</template>
<script>
export default {
    name: 'confirm-component',
    props: {
        text: {
            type: String,
            default: '确定'
        },
        cancelText: {
            type: String,
            default: '取消'
        },
        btns: {
            type: Boolean,
            default: false
        },
    },
    methods: {
        confirm() {
            this.$emit('confirm')
        },
        cancel() {
            this.$emit('cancel')
        },
    },
}
</script>
<style scoped lang="scss">
    .form_submit{
        padding: 0.26667rem 0.53333rem;
        background: #ffffff;
        /* box-shadow: 0 -0.02667rem 0.08rem #ebedf0; */
        margin-top: 0.8rem;
        left: 0;
        position: fixed;
        width: 100%;
        bottom: 0;
        box-sizing: border-box;
        left: 0;
        position: fixed;
        width: 100%;
        bottom: 0;
    }
    .btns{
        display: flex;
        .cancel{
            margin-right: .45rem;
        }
    }
    ::v-deep .me-button--block{
        border-radius: .1rem;
    }
</style>
